export const createCategoryId = (category) => category.toLowerCase().split(' ').join('_');

/**
 * Converts markdown-style bold syntax (*text*) to HTML <b> tags.
 * @param {string} text - Input string potentially containing *bold* markers.
 * @returns {string} String with *text* replaced by <b>text</b>.
 */
export const parseMarkdownBold = (text) => text.replace(/\*([^*]+)\*/g, '<b>$1</b>');
